module.exports = __webpack_public_path__ + "img/hdzcTitleBg.cd298987.png";